import { Draft } from '@reduxjs/toolkit';
import { ILiveSheetState } from './ILiveSheetState';
import { createInitialLiveSheetState } from './liveSheetSlice';

export function applyClearProjectToLayersReducer(_: Draft<ILiveSheetState>) {
  return createInitialLiveSheetState();
}
